import React, { useContext, useEffect, useRef } from "react";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import "./ImageScrollbar";
import $ from "jquery";

const ImageScrollbar = (props) => {
  const element = useRef();
  const style = {
    // width: viewportRow === 1 ? window.innerHeight * 0.795 : window.innerHeight * 0.38,
    width: `${props.elementRef?.current?.clientHeight - 23}px`,
    // width: props.height
  };
  if (props.max === 0) {
    return null;
  }

  return (
    <div className="viewport-scroll">
      <div className="viewport-scroll-holder">
        <input
          className="imageSlider"
          style={style}
          type="range"
          min="0"
          max={props.max}
          step="1"
          value={props.value}
          onChange={props.onChange}
        />
      </div>
    </div>
  );
};

export default ImageScrollbar;
